const chairUrlString = ({ manufactureCode, manufactureDate, invoiceNumber }) => {
  const invoice = invoiceNumber ? `/${invoiceNumber}` : "";
  const manDate = manufactureDate ? `/${manufactureDate}` : "";
  return `/${manufactureCode}${invoice}${manDate}`;
};

export default chairUrlString;
